<template>
  <div class="page-content">
    <page-template ref="requisitionTemplate"
                   :tableOptions="tableOptions"
                   :searchOptions="searchOptions"
                   :toolConfig="toolConfig"
                   :detailColumns="detailColumns"
    ></page-template>
  </div>
</template>

<script>
import pageTemplate from '@/components/template/pageTemplate';
import api from '@/config/api';
import date from '@/mixin/date'

export default {
  mixins: [date],
  components: {
    pageTemplate
  },
  data() {
    return {
      // 高级搜索条件
      searchOptions: {
        simple: [{label: '业务单号', prop: 'orderNo', type: 'input', isFuzzy: true, placeholder: '请输入业务单号'}],
        complex: [
          {
            label: '选择日期',
            prop: 'CreateDttm',
            type: 'dateTimeRangeButton',
            dateType: 'datetime',
            // defaultValue: '10',
            span: 24
          },
          // {
          //   label: '调拨级别',
          //   type: 'select',
          //   prop: 'relateType',
          //   data: this.$utils.getCacheStatus('dnRequireOrder.relateType'),
          //   span: 12,
          //   change: this.selectLevel
          // },
          {
            label: '发货门店',
            type: 'select',
            prop: 'deliverStoreId',
            data: [],
            span: 12,
            isHasAll: true,
            url: api.system.seStore,
          },
          {
            label: '要货门店',
            type: 'select',
            prop: 'requireStoreId',
            data: [],
            span: 12,
            isHasAll: true,
            url: api.system.seStore,
            defaultValue: this.$utils.getSysUser().storeId,
            hidden: this.$utils.getSysUser().storeId === null ? false : true
          },
          {
            label: '审核状态',
            prop: 'auditStatus',
            type: 'select',
            span: 12,
            defaultValue: 10,
            data: [{label: '未审核', value: 10}, {label: '已审核', value: 20}]
          },
          {
            label: '发货状态',
            prop: 'shipmentStatus',
            type: 'select',
            span: 12,
            data: [
              {label: '全部', value: undefined},
              {label: '未发货', value: 30},
              {label: '部分发货', value: 20},
              {label: '已发货', value: 10},
              {label: '已作废', value: 40}]
          }]
      },
      // 更多功能
      toolConfig: [
        {
          label: '新增',
          code: 'insert',
          callback: this.addRequisition
        },
        {
          label: '编辑',
          type: this.$utils.buttonType.tableOperate,
          code: 'update',
          callback: this.toEditPage,
          filter: (data) => {
            return data.auditStatus == 10 ? true : false;
          }
        },
        {
          label: '删除',
          code: 'delete',
          type: this.$utils.buttonType.tableOperate,
          filter: (data) => {
            return data.auditStatus == 10 ? true : false;
          }
        },
        {
          label: '导出',
          code: 'export',
          callback: this.goodsDetailExport,
          filter: () => {
            return false
          }
        },
        {
          label: '作废',
          code: 'nullify',
          type: this.$utils.buttonType.tableOperate,
          filter: (data) => {
            if (data.auditStatus == 20) {//已审核
              return (data.shipmentStatus == 10 || data.shipmentStatus == 40) ? false : true;//已出库 已作废 不显示作废
            } else {
              return false
            }
          },
          callback: this.orderNullify
        },
      ],
      // 表格信息配置
      tableOptions: {
        // 是否显示索引
        tableName: 'clearTable',
        showSelect: true,
        indexShow: true,
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
            width: '230',
            align: 'center',
            showDetail: true
          },
          {
            label: '审核状态',
            prop: 'auditStatus',
            width: '100',
            align: 'center',
            enumData: this.$utils.getCacheStatus('dnRequireOrder.auditStatus')
          },
          // {
          //   label: '调拨级别',
          //   prop: 'relateType',
          //   width: '150',
          //   align: 'center',
          //   enumData: this.$utils.getCacheStatus('dnRequireOrder.relateType')
          // },
          {
            label: '要货门店',
            prop: 'requireStoreName',
            width: '150',
            align: 'center'
          },
          {
            label: '发货门店',
            prop: 'deliverStoreName',
            width: '150',
            align: 'center'
          },

          // {
          //   label: '有效日期',
          //   prop: 'effectiveDttm',
          //   width: '170',
          //   align: 'center'
          // },
          {
            label: '单据金额(元)',
            prop: 'billAmount',
            width: '120',
            align: 'center',
            deal: this.$utils.returnFloat
          },

          {
            label: '制单人',
            prop: 'voucherName',
            width: '120',
            align: 'center'
          },
          {
            label: '制单日期',
            prop: 'voucherDttm',
            width: '150',
            align: 'center'
          },
          {
            label: '审核人',
            prop: 'reviewerName',
            width: '120',
            align: 'center'
          },
          {
            label: '审核日期',
            prop: 'reviewerDttm',
            width: '150',
            align: 'center'
          },
          {
            label: '发货状态',
            prop: 'shipmentStatus',
            width: '100',
            enumData: this.$utils.getCacheStatus('dnRequireOrder.shipmentStatus')
          },
          {
            label: '备注',
            prop: 'remarks',
            width: '120',
            align: 'center'
          }
        ],
        param: {auditStatus: 10, stCreateDttm: this.getStMonthDate(), edCreateDttm: this.getEdMonthDate()},
        url: api.delivery.requisition
      },
      // 详情
      detailColumns: {
        statusOption: {
          prop: 'auditStatus',
          statusImg: {
            20: '/static/checked.png',
            10: '/static/un-check.png'
          },
          right: '100px',
          top: '0'
        },
        span: 8,
        labelWidth: '130',
        columns: [
          {
            label: '业务单号',
            prop: 'orderNo',
            span: 12
          }, {
            label: '要货门店',
            prop: 'requireStoreName',
            span: 12
          },
          // {
          //   label: '调拨级别',
          //   prop: 'relateType',
          //   span: 12,
          //   enumData: this.$utils.getCacheStatus('dnRequireOrder.relateType')
          // },
          {
            label: '发货门店',
            prop: 'deliverStoreName',
            span: 12
          },
          // {
          //   label: '有效日期',
          //   prop: 'effectiveDttm',
          //   span: 12
          // },
          {
            label: '备注',
            prop: 'remarks',
            span: 12
          }],
        tablesProp: {
          goodsMapMVOList: {
            url: api.delivery.requisitionGoods + "/page",
            height: this.detailHeight,
            indexShow: true,
            showSummary: true,
            summaryColumns: ['goodsNum', 'subtotalAmount'],
            tableName: 'goodsMapMVOList',
            columns: [
              {
                label: '条码',
                prop: 'goodsBarCode',
                align: 'center',
                width: '180'
              },
              {
                label: '商品名称',
                prop: 'goodsName',
                align: 'center',
                width: '150'
              },
              {
                label: '规格',
                prop: 'goodsSpecs',
                align: 'center',
                width: '70'
              },
              {
                label: '单位',
                prop: 'goodsUnitName',
                align: 'center',
                width: '70'
              },
              {
                label: '类别',
                prop: 'goodsCategoryName',
                width: '120',
                align: 'center',
              },
              {
                label: '品牌',
                prop: 'goodsBrandName',
                align: 'center',
                width: '120'
              },
              {
                label: '配送价',
                prop: 'deliveryPrice',
                align: 'center',
                width: '100'
              },
              {
                label: '数量',
                prop: 'goodsNum',
                align: 'center',
                width: '100'
              },
              {
                label: '小计金额',
                prop: 'subtotalAmount',
                align: 'center',
                width: '100'
              },
              // {
              //   label: '当前门店库存',
              //   prop: 'goodsInventoryNum',
              //   align: 'center',
              //   width: '135'
              // },
              {
                label: '零售价',
                prop: 'retailPrice',
                align: 'center',
                width: '100'
              },
              {
                label: '备注',
                prop: 'remarks',
                align: 'center',
                width: '150'
              }
            ]
          }
        },
        url: api.delivery.requisitionDetails
      }

    };
  },
  mounted() {
    if (Object.keys(this.$route.params).length > 0) {
      if (this.$route.params.customQuery) {
        let str = this.$route.params.customQuery
        this.tableOptions.param = eval('(' + str + ')')
      }
    }
    this.$nextTick(()=>{
      this.tableOptions.url = api.delivery.requisition
      this.$refs['requisitionTemplate'].operationSuccess();
    })
  },
  methods: {
    addRequisition() {
      this.$router.push({path: '/delivery/requisition/add'});
    },
    toEditPage(row) {
      this.$router.push({path: '/delivery/requisition/add?id=' + row.id + '&auditStatus=' + row.auditStatus});
    },
    selectLevel(data) {
      if (data.relateType === 10) {
        this.searchOptions.complex.filter(item => item.prop === 'deliverStoreId')[0].hidden = true;
      } else {
        this.searchOptions.complex.filter(item => item.prop === 'deliverStoreId')[0].hidden = false;
      }
    },
    goodsDetailExport() {
      let selectData = this.$refs["requisitionTemplate"].$refs["tableTemp"].selectRow;
      if (selectData.length === 0) {
        this.$confirm('请选择一条数据！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } else {
        if (selectData.length > 1) {
          this.$confirm('只能选择一条数据！', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$refs["requisitionTemplate"].$refs["tableTemp"].$refs["clearTable"].clearSelection();
          })
        } else {
          this.$axios.fetchPost(api.delivery.requisitionGoodsExport, {
            orderNo: selectData[0].orderNo,
            exportCode: 'DnRequireGoodsExcel'
          }).then(data => {
            if (data.code === 200) {
              const elink = document.createElement('a');
              elink.href = data.data;
              elink.click();
              this.loadingExt = false;
              this.$notify({
                type: "success",
                title: '导出操作',
                message: '成功',
                showClose: false,
              });
              // this.$message({message: '导出成功', type: 'success'});
            } else {
              this.$notify({
                type: "error",
                title: '导出操作',
                message: '失败',
                showClose: false,
              });
              // this.$message({message: '导出异常', type: 'error'});
            }
          })
        }
      }
    },
    orderNullify(form) {
      //订单作废
      this.$axios.fetchPost(api.delivery.orderNullify, form).then(data => {
        if (data.code === 200) {
          this.$refs['requisitionTemplate'].operationSuccess();
          this.$notify({
            type: "success",
            title: '作废操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '操作成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '作废操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '操作异常', type: 'error'});
        }
      })
    },

  }
}
</script>
<style scoped>
>>> .status-item.item-green {
  background-color: #ed6650;
}

>>> .status-item.item-red {
  background-color: #37c186;
}

</style>



// WEBPACK FOOTER //
// src/page/delivery/Requisition.vue